import React, { useEffect } from 'react'
import styles from './style.module.scss'
import { Redirect, useHistory, useLocation, useParams } from 'react-router'
import { SectionWrapper } from '@Root/HOCs'
import { getDataOptionsFromLocalStorage } from '@Root/helpers'
import { CreateLeaver } from './Create'
import { EditLeaver } from './Edit'
import { useSelector, useDispatch } from 'react-redux'
import { engagementSelectors } from '@Store/studies'
import { modalActions } from '@Store/modal'
import { fieldTooltipManagerActions } from '@Store/fieldTooltipManager'

export const LeaverPage = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const engagement = useSelector(engagementSelectors.engagement)
  const engagementPermissions = useSelector(engagementSelectors.permissions)
  const canBeCreated = engagement.can_be_created_leaver
  const pathname = location.pathname
  const isNew = pathname.includes('new')
  const { id: engagementId, studentId: contactId } = useParams()
  const leaverId = pathname.split('/')[7]

  const DEFAULT_URL = `/home/studies/engagements/${contactId}/${engagementId}/leaver`

  useEffect(() => {
    getDataOptionsFromLocalStorage(['engagement_leaver'])
    dispatch(fieldTooltipManagerActions.getDescriptions({ entity: 'studies', entity_type: 'engagement_leaver' }))
  }, [])

  if (!leaverId) history.push(DEFAULT_URL)

  if (!canBeCreated && leaverId === 'new' && engagement.id) return <Redirect to={DEFAULT_URL} />

  if (engagementPermissions.tabs && !engagementPermissions.tabs.leaver) return <Redirect to={DEFAULT_URL} />

  const onOpenDescriptionModal = (description, title) => {
    new Promise((resolve, reject) => {
      dispatch(
        modalActions.showModal('NotificationModal', {
          text: description,
          clickRejectButtonHandler: reject,
          clickResolveButtonHandler: resolve,
          title,
        })
      )
    }).finally(() => dispatch(modalActions.hideModal()))
  }

  return (
    <SectionWrapper hasBackButton backButtonText={'Engagement Details'} clickBackButtonHandler={() => history.push(DEFAULT_URL)} activeName>
      <div className={styles.sections}>
        {isNew ? (
          <CreateLeaver parentURL={DEFAULT_URL} onOpenDescriptionModal={onOpenDescriptionModal} />
        ) : (
          <EditLeaver parentURL={DEFAULT_URL} onOpenDescriptionModal={onOpenDescriptionModal} />
        )}
      </div>
    </SectionWrapper>
  )
}
